import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IdName } from '../../interfaces/generic.interface';

@Component({
  selector: 'app-autocomplete-field',
  standalone: true,
  imports: [
    MatInputModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  templateUrl: './autocomplete-field.component.html',
  styleUrl: './autocomplete-field.component.css',
})
export class AutocompleteFieldComponent {
  @Input() label!: string;
  @Input() charsMin!: number;
  @Input() isLoading = false;
  @Input() placeholder!: string;
  @Input() controlName!: string;
  @Input() index!: number;
  @Input() formGroup!: FormGroup;
  @Input() highlightFn!: (name: string, term: string) => string;
  @Input() options: IdName[] = [];
  @Input() displayFn!: (value: string | IdName) => string;

  showDescriptionHint = false;

  handleFocus() {
    this.showDescriptionHint = true;
  }

  handleBlur() {
    this.showDescriptionHint = false;
  }

  highlightMatch(option: string, filter: string): string {
    if (!filter || typeof filter !== 'string') {
      return option;
    }
    const escapedFilter = filter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedFilter.toLowerCase()})`, 'gi');
    return option.replace(regex, '<span class="highlight">$1</span>');
  }

  get value(): string {
    return this.formGroup.get(this.controlName)?.value || '';
  }

  clearValue() {
    this.formGroup.get(this.controlName)?.setValue('');
  }

  showHint(): boolean {
    return this.showDescriptionHint && this.value?.length <= 2;
  }
}
